/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createListing} from '../api'

export const useMutationCreateListing = createReactQueryMutationHook('createListing', createListing)
